/* eslint-disable import/prefer-default-export */
export const formatDate = (millinSeconds: string | number | Date) => {
  const date = new Date(millinSeconds)
  const monthArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Spt', 'Oct', 'Nov', 'Dec']

  const year = date.getFullYear()
  const month = monthArr[date.getMonth()]
  const day = date.getDate()

  return `${day} ${month} ${year}`
}

export const convertLockPeriod = (seconds) => {
  const years = Math.floor(seconds / (365 * 24 * 60 * 60))
  const remainingAfterYears = seconds % (365 * 24 * 60 * 60)
  const days = Math.floor(remainingAfterYears / (24 * 60 * 60))
  const remainingAfterDays = remainingAfterYears % (24 * 60 * 60)
  const hours = Math.floor(remainingAfterDays / (60 * 60))
  const remainingAfterHours = remainingAfterDays % (60 * 60)
  const minutes = Math.floor(remainingAfterHours / 60)
  const remainingAfterMinutes = remainingAfterHours % 60
  const secondsRemaining = remainingAfterMinutes

  let result = ''
  if (years > 0) result += `${years} year${years > 1 ? 's' : ''} `
  if (days > 0) result += `${days} day${days > 1 ? 's' : ''} `
  if (hours > 0) result += `${hours} hour${hours > 1 ? 's' : ''} `
  if (minutes > 0) result += `${minutes} minute${minutes > 1 ? 's' : ''} `
  if (secondsRemaining > 0 || result === '') result += `${secondsRemaining} second${secondsRemaining > 1 ? 's' : ''} `

  return result.trim()
}
